import { HorizontalBarChart } from '@talentmesh/charts';
import { getAssessmentAverageValue, getAssessmentInternalAverageValue } from '../BenchmarkUtils';
import ChartBox from './ChartBox';
import { AssessmentMeanBenchmark } from '@/Models/AssessmentMeanBenchmark';
import { TestTypes } from '@/Models/Configuration';
import UIStrings from '@/Utils/UIStrings';

interface OverallScoreBenchmarkTabProps {
    candidateFirstName: string;
    candidateScore: number;
    testType: TestTypes;
    benchmark: AssessmentMeanBenchmark;
}

function OverallScoreBenchmarkTab({
    candidateFirstName,
    candidateScore,
    testType,
    benchmark,
}: OverallScoreBenchmarkTabProps) {
    return (
        <ChartBox>
            <HorizontalBarChart
                candidateScore={{
                    label: UIStrings.SomeoneScore(candidateFirstName),
                    value: candidateScore,
                }}
                averageScore={{
                    label: [UIStrings.AverageOfInvited, UIStrings.InvitedApplicants],
                    value: getAssessmentAverageValue(testType, benchmark),
                }}
                internalScore={{
                    label: [UIStrings.AverageOfInvited, UIStrings.InternalBenchmarks],
                    value: getAssessmentInternalAverageValue(testType, benchmark),
                }}
            />
        </ChartBox>
    );
}

export default OverallScoreBenchmarkTab;
